function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import { LeafletProvider } from './context.js';
export function createContainerComponent(useElement) {
  function ContainerComponent(props, forwardedRef) {
    var _useElement$current = useElement(props).current,
      instance = _useElement$current.instance,
      context = _useElement$current.context;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    return props.children == null ? null : /*#__PURE__*/React.createElement(LeafletProvider, {
      value: context
    }, props.children);
  }
  return /*#__PURE__*/forwardRef(ContainerComponent);
}
export function createDivOverlayComponent(useElement) {
  function OverlayComponent(props, forwardedRef) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];
    var instance = useElement(props, setOpen).current.instance;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    useEffect(function updateOverlay() {
      if (isOpen) {
        instance.update();
      }
    }, [instance, isOpen, props.children]);
    // @ts-ignore _contentNode missing in type definition
    var contentNode = instance._contentNode;
    return contentNode ? /*#__PURE__*/createPortal(props.children, contentNode) : null;
  }
  return /*#__PURE__*/forwardRef(OverlayComponent);
}
export function createLeafComponent(useElement) {
  function LeafComponent(props, forwardedRef) {
    var instance = useElement(props).current.instance;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    return null;
  }
  return /*#__PURE__*/forwardRef(LeafComponent);
}